import React, { useState } from 'react';
import clsx from 'clsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import useStyles from './styles';

const RTVAutocomplete = props => {
  const classes = useStyles();
  const [textInput, setTextInput] = useState('');
  return (
    <Autocomplete
      {...props}
      classes={{
        inputRoot: classes.autocompleteRoot,
        input: classes.autocompleteInput,
        paper: classes.menuPaper
      }}
      forcePopupIcon={false}
      options={textInput.length >= 3 && !props.value ? props.options : []}
      noOptionsText={
        (textInput.length < 3 &&
          !props.value &&
          `Ingrese ${3 - textInput.length} letras para mostrar localidades`) ||
        'No se encontraron localidades'
      }
      disableClearable={textInput.length < 3 && !props.value}
      onInputChange={(_, value, reason) => {
        if (reason === 'reset') {
          setTextInput('');
        } else if (reason === 'input') {
          setTextInput(value);
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          InputProps={{
            ...params.InputProps,
            classes: {
              root: clsx(classes.inputs, classes.select)
            }
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            classes: {
              root: classes.label
            }
          }}
        />
      )}
    />
  );
};

export default RTVAutocomplete;
